module.exports = __webpack_public_path__ + "img/VKDM3E7IA5CLBMVBMA3KTMFTRQ.65aed329.jpg";